import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import Konva from 'konva';

function draw(opts: {
    modelLine: ILongSectionDrawableObject,
    type: 'model' | 'terrainModel',
    isBackground: boolean,
    csCanvas: CrossSectionCanvas,
    onClickCallback: (logpoint: ILongSectionDrawableObject, x: number, y: number) => void
}) {
    const { modelLine, type, isBackground, csCanvas, onClickCallback } = opts;
    const canvasOptions = csCanvas.canvasOptions;
    const lowestPoint = csCanvas.lowestPoint;
    const center = canvasOptions.side_margin / 2 + csCanvas.panX;

    const color = getRgb(modelLine.color);
    const components = modelLine.color.match(/\d+/g).map(parseFloat);
    components[0] += 200;
    components[1] += 200;
    components[2] += 200;
    components[0] = Math.min(components[0], 255);
    components[1] = Math.min(components[1], 255);
    components[2] = Math.min(components[2], 255);

    modelLine.vectors.forEach(vector => {
        let skipLine = false;
        let oldX1 = -1000;
        let oldY1 = 0;
        if (vector.points.length < 2) {
            return true;
        }
        for (let i = 0; i < vector.points.length - 1; i++) {
            let x0: number;
            let y0: number;
            if (skipLine) {
                x0 = oldX1;
                y0 = oldY1;
                skipLine = false;
            } else {
                x0 = center + (vector.points[i].x * canvasOptions.x_scale);
                y0 = (csCanvas.height - canvasOptions.bottom_margin) + lowestPoint * canvasOptions.y_scale - (vector.points[i].y * canvasOptions.y_scale) + csCanvas.panY;
            }
            const x1 = center + (vector.points[i + 1].x * canvasOptions.x_scale);
            const y1 = (csCanvas.height - canvasOptions.bottom_margin) + lowestPoint * canvasOptions.y_scale - (vector.points[i + 1].y * canvasOptions.y_scale) + csCanvas.panY;
            if (x1 - oldX1 < 10) {
                skipLine = true;
                continue;
            }
            oldX1 = x1;
            oldY1 = y1;

            if (x0 < canvasOptions.side_margin / 2 && x1 < canvasOptions.side_margin / 2) {
                continue;
            } else if (x0 > csCanvas.width - canvasOptions.side_margin / 2 && x1 > csCanvas.width - canvasOptions.side_margin / 2) {
                continue;
            } else if (y0 < canvasOptions.top_margin && y1 < canvasOptions.top_margin) {
                continue;
            } else if (y0 > csCanvas.height - canvasOptions.bottom_margin && y1 > csCanvas.height - canvasOptions.bottom_margin) {
                continue;
            }

            const modelLayer = csCanvas.contentLayer;
            const slope = Math.abs((y1 - y0) / ((x1 - x0) * csCanvas.yScale));
            const lineObj = new Konva.Line({
                visible: true,
                name: 'model_' + modelLine.modelId,
                points: [x0, y0, x1, y1],
                stroke: color,
                strokeWidth: modelLine.strokeWidth,
                lineCap: 'round',
                lineJoin: 'round',
                listening: false
            });

            const tooltipLine = new Konva.Line({
                visible: true,
                name: 'tooltipline_model_' + modelLine.modelId,
                points: [x0, y0, x1, y1],
                stroke: color,
                strokeWidth: 4,
                lineCap: 'round',
                lineJoin: 'round',
                listening: true,
                opacity: 0
            });
            tooltipLine.on('mouseover', function () {
                lineObj.strokeWidth(lineObj.strokeWidth() + 2);
                showTooltip(modelLine.name, slope, csCanvas);
                modelLayer.draw();
            });
            tooltipLine.on('mouseout', function () {
                lineObj.strokeWidth(lineObj.strokeWidth() - 2);
                modelLayer.draw();
                csCanvas.clearTooltips();
            });

            if (type === "terrainModel") {
                lineObj.dash([9, 9]);
            }
            modelLayer.add(lineObj);
            modelLayer.add(tooltipLine);
        }
    });
}


const showTooltip = (modelName: string, slope: number, csCanvas: CrossSectionCanvas) => {
    let t = [modelName];
    t.push("perc: " + slope.toFixed(3) + "   (" + (slope * 100.0).toFixed(1) + "%)");
    t.push("deg:  " + (slope * 90).toFixed(1) + "°");
    const x = csCanvas.mouseX;
    const y = csCanvas.mouseY;

    const text = new Konva.Text({
        name: 'vertex_hover_text',
        x,
        y: y - 50,
        text: t.join('\n'),
        fontSize: 12,
        fontFamily: 'Calibri',
        fill: 'black',
        listening: false
    });
    text.offsetX(text.width() / 2);
    text.offsetY(text.height());

    const boxw = text.width() + 10;
    const boxh = text.height();
    const box = new Konva.Rect({
        x: x - boxw / 2,
        y: y - text.offsetY() - 50 - 5,
        width: boxw,
        height: boxh,
        fill: 'rgba(255,255,255,128)',
        opacity: 0.8,
        listening: false
    });

    csCanvas.tooltipLayer.add(box);
    csCanvas.tooltipLayer.add(text);
    csCanvas.tooltipLayer.draw();
}

const getRgb = (color: string) => 'rgb(' + color + ')'

export const LongSectionDrawableModel = {
    draw
}
